import { __assign } from "tslib";
import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import theme from '../../theme';
/**
 * @public
 */
var ThemeProvider = function (props) {
    return React.createElement(MuiThemeProvider, __assign({ theme: theme }, props));
};
export default ThemeProvider;
/** @private @internal for docs only! */
export var DocsThemeProvider = function (props) { return (React.createElement(ThemeProvider, __assign({}, props))); };
//# sourceMappingURL=ThemeProvider.js.map